/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import React from 'react';
import toast from 'react-hot-toast';
import { assetsService } from '../../../../api/services/assetsService';
import { setAllActiveAssets } from '../../../../infra/aggregates/myProfile/AssetsAggregates/activeAssetsSlice';
import { setAllReturnAssets } from '../../../../infra/aggregates/myProfile/AssetsAggregates/returnAssetSlice';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import ReturnAssetModalPresenter from './ReturnAssetPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  returnassetDetails: any;
  trans?: any;
}

const ReturnAssetModalController = ({
  isModalOpen,
  closeModal,
  returnassetDetails,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  const getData = (data: any) => {
    returnAsset(data);
  };
  const storeReturnAssets: any = useAppSelector(
    (state) => state.returnAssetSlice.returnAssets,
  );
  const storeActiveAssets: any = useAppSelector(
    (state) => state.activeAssetsSlice.activeAssets,
  );
  async function returnAsset(data: any) {
    if (selector) {
      const payload = {
        emp_id: selector.emp_id,
        company_id: selector.company_id,
        assetId: data.assetId,
        returnReason: data.returnReason,
        remarks: data.remarks,
      };

      const response: any = await assetsService.returnAssetRequest(payload);
      if (response.response == 'success') {
        const tempAssets = [...storeReturnAssets];
        const tempAssetActive = [...storeActiveAssets];
        tempAssets.push(response?.data);
        dispatch(setAllReturnAssets(tempAssets));

        const activeList = _.filter(tempAssetActive, (data: any) => {
          return data.id !== response?.data?.id;
        });

        dispatch(setAllActiveAssets(activeList));
        toast.success(trans('Asset Returned Successfully'));
      }
    }
  }
  return (
    <ReturnAssetModalPresenter
      returnassetDetails={returnassetDetails}
      callBackReturnAsset={getData}
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      trans={trans}
    />
  );
};
export default ReturnAssetModalController;
